import React, { PureComponent } from "react";
import { connect } from "react-redux";
import images from "assets/images";
import get from "lodash/get";

import { getPricing } from "actions/pricing/pricing.functions";
import { PriceSelector, SEO, Loader } from "components";

import { getPage } from "actions/page/page.functions";

class Pricing extends PureComponent {
  state = {
    selectedCountry: undefined
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPricing());

    let slug = "pricing";
    dispatch(getPage(slug));
  }

  componentWillUpdate(nextProps, nextState) {
    const { pricingItems } = this.props;

    // Set USA as first item
    if (!pricingItems && nextProps.pricingItems) {
      const USA = nextProps.pricingItems.find(
        item => item.value === "United States of America"
      );

      this.setState({
        selectedCountry: USA
      });
    }
  }

  handleUpdatePricing = selectedCountry => {
    this.setState({
      selectedCountry
    });
  };

  render() {
    const { selectedCountry } = this.state;

    const { pricingIsFetching, pricingItems, singlePage } = this.props;

    const priceSelectorProps = {
      pricingItems,
      selectedCountry,
      updatePriceCallback: this.handleUpdatePricing
    };

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    return (
      <main className="view-pricing">
        <SEO {...seoProps} />
        <section className="view-pricing__splash">
          <div className="wrapper">
            <div className="view-pricing__splash__heading">
              <h1 className="u-type--beta u-type--primary">Pricing</h1>
            </div>
            <div className="view-pricing__splash__content">
              <div className="view-pricing__splash__content__subheading">
                <p className="u-type--delta u-type--o50">
                  Chat and Calls within Biond are always free. Calls to Mobile
                  and Landline and SMS at great price.
                </p>
              </div>
              <div className="view-pricing__splash__content__explainer">
                <p className="u-type--zeta u-type--o50">
                  Reach your friends and family outside Biond. Biond Out enables
                  calling mobile and landline numbers worldwide at attractive
                  rates for premium voice quality.
                </p>
              </div>
            </div>
            <div className="view-pricing__splash__visual">
              <img alt="Pricing" src={images.illustrationCoins} />
            </div>
          </div>
        </section>

        <section className="view-pricing__pricing">
          <div className="wrapper">
            <div className="view-pricing__pricing__layout">
              <div className="view-pricing__pricing__layout__heading">
                <h3 className="u-type--gamma u-type--negative u-spc-bottom--xlrg">
                  Great prices around the world.
                </h3>
                <p className="pricing__subtitle u-type--negative u-type--o50">
                  With Biond SMS you can send messages to your friends who are
                  still not Biond users. More than 200 destinations over the
                  world are supported.
                </p>
              </div>
              <div className="view-pricing__pricing__layout__content">
                <p className="u-type--zeta u-type--negative u-type--o50 u-spc-bottom--xlrg">
                  Calculate cellular costs for mobile, landline numbers and SMS.
                </p>
                {pricingIsFetching ? (
                  <Loader />
                ) : (
                  <PriceSelector {...priceSelectorProps} />
                )}
              </div>
            </div>
          </div>
        </section>

        <section className="section section--primary section--orange u-type--center">
          <div className="wrapper">
            <h2 className="u-type--gamma u-type--negative u-spc-bottom--xlrg">
              Download pricing table
            </h2>
            <button
              type="button"
              className="btn btn--med btn--negative u-rounded"
            >
              Download
            </button>
          </div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { pricingItems, pricingIsFetching } = state.pricing;
  const { singlePage } = state.pages;

  return {
    pricingIsFetching,
    pricingItems,
    singlePage
  };
};

export default connect(mapStateToProps)(Pricing);



// WEBPACK FOOTER //
// ./src/views/Pricing.jsx